import React from 'react';
import { LinkModel, ModuleBaseNameProps } from '@/types';
import classNames from 'classnames';
import { Link, RichText, Stack } from '@/components';
import ArrowShort from '@/assets/arrowShort.svg';

export type InfoBlockTextElementModel = {
  text?: string;
  link: LinkModel[];
} & ModuleBaseNameProps &
  React.HTMLAttributes<HTMLDivElement>;

export const InfoBlockTextElement = ({ text, link, className }: InfoBlockTextElementModel) => {
  return (
    <Stack className={classNames('text-element flex flex-col', className)}>
      {text && <RichText className="color-from-bg" data={text} />}
      {link && link.length > 0 && (
        <div className="mb-5 flex gap-3 pt-3 md:mb-0">
          {link.map((linkItem, index) => (
            <Link
              animate
              className="btn secondary group btn-from-bg bg-black/10 !py-3 !tracking-normal hover:!bg-[#f5bda2] hover:!text-black"
              key={index}
              link={linkItem}
            >
              <span>{linkItem.text}</span>

              <ArrowShort className="fill-from-bg h-4 w-4 rotate-180 group-hover:fill-black" />
            </Link>
          ))}
        </div>
      )}
    </Stack>
  );
};

export default InfoBlockTextElement;
